module.exports = __webpack_public_path__ + "static/hall-31f0bf1976e607c3332186474eb585a4.jpg";